/* Lab401: Re-inject ATC cart icon after theme JS replaces button text on variant change.
   Empire's _updateButton() calls $button.text(...) which wipes all inner HTML. */
(function() {
  var SVG_NS = 'http://www.w3.org/2000/svg';
  var PATH_D = 'M0-232c0-9 7-16 16-16h45c24 0 43 17 48 39L148 8h319c19 0 35-13 39-32l38-179c2-9 11-14 19-13 9 2 15 11 13 19L537-17c-7 33-36 57-70 57H154l5 31c4 19 20 33 40 33h265c9 0 16 7 16 16s-7 16-16 16H199c-35 0-65-25-71-59L77-203c-1-7-8-13-16-13H16c-9 0-16-7-16-16zm208 464c11 0 20-9 20-20s-9-20-20-20-20 9-20 20 9 20 20 20zm0-72c29 0 52 23 52 52s-23 52-52 52-52-23-52-52 23-52 52-52zm244 52c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm-72 0c0-29 23-52 52-52s52 23 52 52-23 52-52 52-52-23-52-52zM325-61l-72-72c-6-6-6-16 0-22s16-6 22 0l45 44v-121c0-9 7-16 16-16s16 7 16 16v121l45-44c6-6 16-6 22 0 7 6 7 16 0 22l-72 72c-6 7-16 7-22 0z';

  function createIconSvg() {
    var svg = document.createElementNS(SVG_NS, 'svg');
    svg.setAttribute('xmlns', SVG_NS);
    svg.setAttribute('width', '598');
    svg.setAttribute('height', '532');
    svg.setAttribute('viewBox', '-10 -258 598 532');
    var path = document.createElementNS(SVG_NS, 'path');
    path.setAttribute('d', PATH_D);
    path.setAttribute('fill', 'currentColor');
    svg.appendChild(path);
    return svg;
  }

  function ensureIcon(button) {
    if (button.querySelector('.atc-button--circle-icon')) return;
    if (button.classList.contains('disabled') || button.hasAttribute('disabled')) return;
    var text = button.textContent.trim();
    button.textContent = '';
    var iconSpan = document.createElement('span');
    iconSpan.className = 'atc-button--circle-icon';
    iconSpan.appendChild(createIconSvg());
    var textSpan = document.createElement('span');
    textSpan.className = 'atc-button--text';
    textSpan.textContent = text;
    button.appendChild(iconSpan);
    button.appendChild(textSpan);
  }

  function initAll() {
    document.querySelectorAll('.product-form--atc-button').forEach(function(btn) {
      ensureIcon(btn);
      var observer = new MutationObserver(function() {
        ensureIcon(btn);
      });
      observer.observe(btn, { childList: true, characterData: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
